import * as React from 'react';
import { flow, each, get } from 'lodash';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import { IClaim } from '../../../../../../data/api/models';
import Claim from '../Claim';
import { Button } from 'react-bootstrap';

interface IClaimsProps {
  claims: IClaim[];
  claimDataPath: string;
  fields: any;
  dispatch: any;
  change: any;
  renderDefinition: any;
  claimOptions: any;
}

const defaults = {
  date: '',
  type: '',
  cost: 0,
  fault: '',
  open: '',
};

class Claims extends React.Component<IClaimsProps> {
  public addClaim = () => {
    const { fields } = this.props;

    fields.push(defaults);
  }

  public deleteClaim = (index) => {
    const { fields } = this.props;

    fields.remove(index);
  }

  public render() {
    const { fields, claims, dispatch, change, claimOptions } = this.props;

    return (
      <div>
        {fields.map((claim, index) => {
          return (
            <div key={index}>
              <Claim
                name={claim}
                claim={claims[index]}
                index={index}
                dispatch={dispatch}
                change={change}
                claimOptions={claimOptions}
                removable={fields.length > 1}
                deleteClaim={this.deleteClaim}
              />
              {index + 1 !== fields.length && (
                <hr />
              )}
            </div>
          );
        })}
        {fields.length < 20 && (
          <div className="margin-bottom">
            <Button
              bsStyle="primary"
              className="btn-postcode"
              type="button"
              onClick={this.addClaim}
            >
              {`Add${fields.length < 1 ? '' : ' Another'} Claim`}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore, props: IClaimsProps) => {
      const claims = selector(state, props.claimDataPath + '.claims');

      return {
        quote: state.quote,
        claims,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(Claims);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Drivers/components/Claims/index.tsx